import { Model } from '@datamodel';

export class PickupBar extends Model {
    static get uuid() { return 'pickupBarId' };
    static get model() {
        return ({
            name: '',
            hasStandardPickup: false,
            hasPreparedPickup: false,
            hasDelivery: false,
            place: Place.model
        })
    }

    static get keymap() {
        return {
            id: PickupBar.uuid,
        }
    }

    static get parseMap() {
        return {
            place: p => Place.parse(p)
        }
    }

    static get unserialMap() {
        return {
            place: p => Place.unserialize(p)
        }
    }

    static get toClassMap() {
        return {
            place: p => new Place(p)
        }
    }

    static getAnyPrepared(pickupBars) {
        const pb = pickupBars.find(pb => pb.hasPreparedPickup) || {};
        return pb.pickupBarId;
    }

    static getAnyDelivery(pickupBars) {
        const pb = pickupBars.find(pb => pb.hasDelivery) || {};
        return pb.pickupBarId;
    }
}


export class Business extends Model {
    static CACHE = 1000 * 60 * 5;
    static get uuid() { return 'businessId' };

    static get model() {
        return ({
            name: '',
            taxId: '',
            businessType: '',
            address: '',
            phone: '',
            emailAddress: '',
        });
    }

    static get keymap() {
        return {
            id: Business.uuid,
        };
    }

    constructor(args) {
        super(args);
        Object.assign(this, Business.unserialize({ ...Business.model, ...args }, { toClass: true }))
    }
}

export class Place extends Model {
    static CACHE = 1000 * 60 * 5;
    static get uuid() { return 'placeId' };
    static get model() {
        return ({
            address: '',
            slug: '',
            name: '',
            pic: 'https://i.gyazo.com/4d63de0782d3f6c5efb94342a6b7b801.png',
            menuSalesAvailable: false,
            primaryColor: '',
            secondaryColor: '',
            minimumOrderAmount: 0,
            logoURL: '',
            maximumOrderAmount: null,
            maximumItemsPerOrder: null,
        })
    }

    static get keymap() {
        return {
            id: Place.uuid,
            photo_url: 'pic',
            logo_url: 'logoURL'
        }
    }

    static shouldFetch({ object, ignoreCache, forceEvents }) {
        let emptyEvents = null;
        if (object && object.events) {
            emptyEvents = (object.events.upcoming.length + object.events.ended.length) < 1
        }
        return Model.shouldFetch({ object, ignoreCache }) || (forceEvents && emptyEvents);
    }

    static canSellExternalTickets(place) {
        // Can sell external tickets if ticketURL is available
        return (place.ticketURL !== null)
    }

    constructor(args) {
        super(args);
        Object.assign(this, Place.unserialize({ ...Place.model, ...args }, { toClass: true }))
    }

}
